import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const headerRef = useRef(null);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close the menu if the click is outside the header.
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    // Add event listener when the menu is open.
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    // Clean up the event listener when the component unmounts or the menu closes.
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <header 
      className="bg-white/90 backdrop-blur-md shadow-lg rounded-xl mx-auto mt-4 px-6 py-3 max-w-[1300px] flex items-center justify-between relative z-50"
      ref={headerRef}
    >
      <div className="flex items-center space-x-2">
        <img src="assets/logo1.png" alt="Dereja Logo" className="h-10 w-auto" />
      </div>

      <nav className="hidden md:flex space-x-6 text-gray-700 font-medium">
        <Link to="/" className="hover:text-orange-600">Home</Link>
        <Link to="/gallery" className="hover:text-orange-600">Gallery</Link>
        <HashLink smooth to="/#achievements" className="hover:text-orange-600">Achievements</HashLink>
        <HashLink smooth to="/#journey" className="hover:text-orange-600">Dereja Journey</HashLink>
        <HashLink smooth to="/#youth" className="hover:text-orange-600">Youth Voices</HashLink>
        {/* <HashLink smooth to="/#hub" className="hover:text-orange-600">Knowledge Hub</HashLink> */}
      </nav>

      <div className="hidden md:block">
        <a
          href="https://dereja.com/contact-us"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-orange-500 hover:bg-orange-600 text-white font-semibold px-5 py-2 rounded-md transition duration-200"
        >
          Get in touch
        </a>
      </div>

      <div className="md:hidden">
        <button onClick={toggleMenu} className="text-orange-600 focus:outline-none text-2xl">
          {isOpen ? '✕' : '☰'}
        </button>
      </div>

      {isOpen && (
        <div className="absolute top-20 left-0 w-full bg-white rounded-b-xl shadow-md z-50 py-4 px-6 md:hidden space-y-3 text-gray-700 font-medium">
          <Link to="/" onClick={toggleMenu} className="block hover:text-orange-600">Home</Link>
          <Link to="/gallery" onClick={toggleMenu} className="block hover:text-orange-600">Gallery</Link>
          <HashLink smooth to="/#achievements" onClick={toggleMenu} className="block hover:text-orange-600">Achievements</HashLink>
          <HashLink smooth to="/#journey" onClick={toggleMenu} className="block hover:text-orange-600">Dereja Journey</HashLink>
          <HashLink smooth to="/#youth" onClick={toggleMenu} className="block hover:text-orange-600">Youth Voices</HashLink>
          {/* <HashLink smooth to="/#hub" onClick={toggleMenu} className="block hover:text-orange-600">Knowledge Hub</HashLink> */}
          <a
            href="https://dereja.com/contact-us"
            target="_blank"
            rel="noopener noreferrer"
            className="block mt-2 text-center bg-orange-500 hover:bg-orange-600 text-white font-semibold px-4 py-2 rounded-md"
          >
            Get in touch
          </a>
        </div>
      )}
    </header>
  );
}

export default Header;